import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, ListItemAvatar } from "@mui/material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Link } from "react-router-dom";
import LoadingGrid from "components/Loading/LoadingFull";
import MeuPlanoAtual from "components/Uteis/MeuPlanoAtual";
import MySnackbarErro from "components/Uteis/MySnackbarErro";
import React, { useEffect, useState } from "react";
import api from "services/api.js";
import { serverApi } from "services/constante.js";
import { CardPedido } from "components/Card/CardPedido";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: 'trnsparent',
    },
    titulo: {
        fontSize: '14px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500
    },
    inline: {
        display: 'inline',
        color: '#787878',
        fontFamily: 'Montserrat, sans-serif',
    },
    iconColor: {
        color: "#FFF"
    },
    boxPontosDK: {
        position: 'absolute',
        bottom: '15px',
        left: '2px',
        color: '#737495'
    },
    boxPontosMB: {
        position: 'absolute',
        bottom: '0px',
        left: '5px',
        top: '30px',
        color: '#737495'
    },
    itemList: {
        display: "flex",
        flexDirection: 'column',
        position: 'relative',
        backgroundColor: 'white',
        marginBottom: '15px',
        borderRadius: '10px',
        border: "1px solid #e2e2e2",
        flex: 1,
        padding: "10px 15px 15px 15px !important",
        marginRight: '20px',
        marginLeft: '20px',
        minWidth: '340px',
        cursor: 'pointer',
        textDecoration: 'none',
    },
    statusDisplay: {
        width: 10,
        height: 10,
        display: 'inline-block',
        // borderRadius: '5px',
        marginRight: '5px'
    },
    boxStatus: {
        marginRight: '7px',
        fontFamily: 'Montserrat, sans-serif',
    },
    textStatusDisplay: {
        color: '#787878'
    },
    boxConteudo: {
        paddingLeft: '5px'
    },
    headerDivider: {
        borderLeft: '1px solid #e2e2e2',
        borderRight: '1px solid #e2e2e2',
        height: '77px',
        position: 'absolute',
        left: '65px',
        top: '35px'
    }
}));


export default function Pedidos(props) {
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [pedidos, setPedidos] = useState([]);
    const [isErro, setIsErro] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const classes = useStyles();

    const carregarDados = async () => {
        try {
            setIsErro(false);
            setLoadingGrid(true);

            const userResponse = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
            const user = userResponse.data;
            const userGuid = user.Guid;

            const formData = new FormData();
            formData.append("function", "get_vendas_pendentes");
            formData.append("guid", userGuid);

            const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

            setPedidos(res.data?.reverse());
        } catch (e) {
            console.error(e);
            setErrorMessage("Não foi possível consultar seus pedidos no momento.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const formatarValor = (pedido) => {
        const value = (pedido.ValorTotalDesconto != null) ? pedido.ValorTotalDesconto : pedido.ValorTotal;
        const numericValue = Number.parseFloat(value);
        return numericValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    const getProdutosTexto = (produtos) => {
        return produtos.map(produto => `• ${produto}`).join("\n");
    }

    useEffect(() => {
        carregarDados();
    }, []);

    return (
        <div>
            <LoadingGrid display={loadingGrid} />
            <div style={{ display: (!loadingGrid && !isErro ? '' : 'none'), display: "flex", flexDirection: "column", alignItems: "start" }}>
                <MeuPlanoAtual />

                <div style={{ padding: "10px 0" }}>
                    <Link to={`pedidos/historico`}>
                        <Button className={classes.btnComprarNew} variant="text" color="primary">
                            Ver meu histórico de pedidos
                        </Button>
                    </Link>
                </div>

                <GridContainer style={{ paddingTop: 20, display: "flex", flexDirection: "column", flex: 1, width: "100%" }}>
                    {(pedidos == null || pedidos.length === 0) && (
                        <div style={{ paddingLeft: 30 }}>
                            <h5>
                                Você não possuí nenhum pedido aguardando pagamento.
                            </h5>
                        </div>
                    )}

                    {pedidos.map((pedido, i) => (
                        <CardPedido
                            key={i}
                            titulo="Produtos:"
                            descricao={getProdutosTexto(pedido.Produtos)}
                            valorTotal={formatarValor(pedido)}
                            pedidoId={pedido.Id}
                        />
                        // <ListItem alignItems="flex-start" className={classes.itemList}>
                        //         <div>
                        //             <h5>Produtos:</h5>
                        //             <ul>
                        //                 {pedido.Produtos?.map((produto, j) => (
                        //                     <li key={j}>{produto}</li>
                        //                 ))}
                        //             </ul>
                        //         </div>

                        //         <h5 style={{ padding: 0, margin: 0 }}>
                        //                                                                                                                  {formatarValor(pedido.ValorTotal)}
                        //         </h5>

                        //         <Link to={`venda/pedido/contrato/${pedido.Id}`} key={i}>
                        //             <Button variant="contained" style={{ marginTop: 10, flex: 1 }}>
                        //                 Pagar
                        //             </Button>
                        //         </Link>
                        // </ListItem>
                    ))}
                    {/* <GridItem xs={12} sm={12} md={4}>
                  <Card className={classes.cardBorderTop} profile>
                    <CardBody profile>
                      <h2>PLANO</h2>
                      <h4>{usuario.Descricao}</h4>
                      <div className="normal text-muted text-left">
                        <span>Máximo de Veículos: <b>{usuario.MaxVeiculo}</b></span>
                      </div>
                      <div className="normal text-muted text-left">
                        <span>Máximo de Condutores: <b>{usuario.MaxHabilitacao}</b></span>
                      </div>
                      <Button type="button" color="info" href="planos" className={classes.btnInfoPlano}>Detalhes do plano</Button>
                    </CardBody>
                  </Card>
                </GridItem> */}
                </GridContainer>
            </div>
            <MySnackbarErro IsErro={isErro} Mensagem={errorMessage} />
        </div>
    );
}